import bankAccounts from "./bankAccounts.json";
// const bicPattern = /^[A-Z]{6}/

export function checkIBAN(iban: string) {
    if (!iban) {
        return false;
    }
    if (iban.length < 14 || iban.length > 34) {
        return false;
    }
    if (!iban.match(/^[A-Z]{2}[0-9]{7}/i)) {
        return false;
    }
    const town = iban.substring(0, 2);
    if (town.toUpperCase() === "FR") {
        if (iban.length !== 27) {
            return false;
        }
        // const code = iban.substring(4,9)
        // const bankAccount = bankAccounts.find(ba => ba.code === code)
        // if (!bankAccount) {
        //     return false
        // }
    }
    return true;
}

export function checkBIC(bic: string) {
    if (!bic) {
        return false;
    }
    // https://www.capital.fr/votre-argent/code-bic-quest-ce-que-cest-ou-le-trouver-1416084?amp
    if (bic.length !== 8 && bic.length !== 11) {
        return false;
    }
    if (bic.length === 8) {
        if (!bic.match(/^[A-Z]{6}[A-Z0-9]{2}/i)) {
            return false;
        }
    } else if (bic.length === 11) {
        if (
            !bic.match(/^[A-Z]{6}[A-Z0-9]{2}[0-9]{3}/i) && // ends with 3 numbers
            !bic.match(/^[A-Z]{6}[A-Z0-9]{2}[A-Z]{3}/i)
        ) {
            // ends with 3 characters
            return false;
        }
    }
    return true;
}

export function getBICFromIBAN(iban: string) {
    if (!iban) {
        return "";
    }
    if (iban?.length < 7) {
        return undefined;
    }
    const code = iban.substring(4, 9);
    debugger;
    const bankAccount = bankAccounts.find((ba) => ba.code === code);
    if (bankAccount?.bic) {
        return bankAccount.bic;
    }
    return "";
}

export function getBankNameFromIban(iban: string) {
    if (!iban) {
        return "";
    }
    if (iban?.length < 7) {
        return undefined;
    }
    const code = iban.substring(4, 9);
    const bankAccount = bankAccounts.find((ba) => ba.code === code);
    if (bankAccount?.name) {
        return bankAccount.name;
    }
    return "";
}

function cleanWord(word) {
    const cw = word.replace(/ {1,}/g, "");
    return cw;
}

export function onIbanChanged(bankAccount) {
    bankAccount.iban = cleanWord(bankAccount.iban);
    const newBIC = getBICFromIBAN(bankAccount.iban);
    if (newBIC) {
        if (newBIC !== bankAccount.bic) {
            bankAccount.bic = newBIC;
        }
    } else if (!bankAccount.bic) {
        bankAccount.bic = "";
    }
    const name = getBankNameFromIban(bankAccount.iban);
    if (name) {
        if (name !== bankAccount.name) {
            bankAccount.name = name;
        }
    } else if (!bankAccount.name) {
        bankAccount.name = "";
    }
}

export function checkICS(ics: string) {
    if (!ics) {
        return false;
    }
    // https://www.capital.fr/votre-argent/code-bic-quest-ce-que-cest-ou-le-trouver-1416084?amp
    if (ics.length !== 13) {
        return false;
    }

    if (!ics.match(/^[a-z]{2}[0-9]{2}[a-z]{3}[0-9A-Z]{6}$/i)) {
        return false;
    }

    return true;
}
